export * from './src/platform-v1-wishlist-wishlist.meta.js';
